// The parts of an employee save, in the order handleSubmit sends them. Each one waits for the previous to finish,
// so when one is still processing after polling stops, the ones after it haven't been sent.
export const SAVE_STEPS = {
  GWS_PRIMARY_EMAIL: 'gwsPrimaryEmail',
  EMPLOYEE_DETAILS: 'employeeDetails',
  USER_PROPERTIES: 'userProperties',
  M365_GROUPS: 'm365Groups',
  SECURITY_GROUPS: 'securityGroups',
  LICENSES: 'licenses',
  POWERSHELL_ACCESS: 'powershellAccess',
}

export const SAVE_STEP_LABEL_IDS = {
  [SAVE_STEPS.GWS_PRIMARY_EMAIL]: 'EDIT_EMPLOYEE.SAVE_STEP.PRIMARY_EMAIL',
  [SAVE_STEPS.EMPLOYEE_DETAILS]: 'EDIT_EMPLOYEE.SAVE_STEP.EMPLOYEE_DETAILS',
  [SAVE_STEPS.USER_PROPERTIES]: 'EDIT_EMPLOYEE.SAVE_STEP.USER_PROPERTIES',
  [SAVE_STEPS.M365_GROUPS]: 'EDIT_EMPLOYEE.SAVE_STEP.M365_GROUPS',
  [SAVE_STEPS.SECURITY_GROUPS]: 'EDIT_EMPLOYEE.SAVE_STEP.SECURITY_GROUPS',
  [SAVE_STEPS.LICENSES]: 'EDIT_EMPLOYEE.SAVE_STEP.LICENSES',
  [SAVE_STEPS.POWERSHELL_ACCESS]: 'EDIT_EMPLOYEE.SAVE_STEP.POWERSHELL_ACCESS',
}

const hasGroupChanges = (groups) => groups?.toBeAdded?.length > 0 || groups?.toBeRemoved?.length > 0

/**
 * The save steps this payload needs, in send order
 *
 * @param {{ payload: Object, isGws: boolean, employee: Object, selectedCustomer: Object }} params
 * @returns {string[]} SAVE_STEPS values
 */
export const getPlannedSaveSteps = ({ payload, isGws, employee, selectedCustomer }) => {
  const canManageMicrosoftUser = !isGws && Boolean(employee?.employeeIdentifier) && Boolean(selectedCustomer)
  const hasGwsEmailChange = isGws && typeof payload.sql?.email === 'string'
  // The GWS email change stores the email itself, so it isn't part of the employee details update
  const employeeDetailFields = Object.keys(payload.sql ?? {}).filter(
    (field) => !(hasGwsEmailChange && field === 'email'),
  )
  const licenseChanges = payload.licensesChanges

  const stepIsNeeded = {
    [SAVE_STEPS.GWS_PRIMARY_EMAIL]: hasGwsEmailChange,
    [SAVE_STEPS.EMPLOYEE_DETAILS]: employeeDetailFields.length > 0,
    [SAVE_STEPS.USER_PROPERTIES]: canManageMicrosoftUser && Object.keys(payload.graphApiProperties ?? {}).length > 0,
    [SAVE_STEPS.M365_GROUPS]: canManageMicrosoftUser && hasGroupChanges(payload.groupsChanges?.m365Groups),
    [SAVE_STEPS.SECURITY_GROUPS]: canManageMicrosoftUser && hasGroupChanges(payload.groupsChanges?.securityGroups),
    [SAVE_STEPS.LICENSES]:
      Boolean(selectedCustomer) && (licenseChanges?.toBeAdded?.length > 0 || licenseChanges?.toBeRemoved?.length > 0),
    [SAVE_STEPS.POWERSHELL_ACCESS]: canManageMicrosoftUser && payload.powershellAccessChanged !== undefined,
  }

  return Object.values(SAVE_STEPS).filter((step) => stepIsNeeded[step])
}
